import { CommanderStatusAPIResponse } from './CommanderStatusAPI.model';
import { restClient } from '../../../../axios';
import _ from 'lodash';
import Util from '../../../../util/Util';
import { STAxiosInstance } from '../../../../axios/STAxios';

export class CommanderStatusAPIService {
  readonly backendDeviceStatusServiceURL =
    new Util().getDeviceStatusServiceURL();
  public constructor(private axios: STAxiosInstance = restClient) {}

  getCommandersConnectionStatus = async (
    commandersId: string[]
  ): Promise<CommanderStatusAPIResponse[]> => {
    if (commandersId.length > 50) {
      // split it and call the api multiple times recursively
      // because the api can only handle 50 ids at a time (url long limitation)
      const responses = await Promise.all(
        _.chunk(commandersId, 50).map((chunk) => {
          return this.getCommandersConnectionStatus(chunk);
        })
      );
      return _.flatten(responses);
    }

    const response = await this.axios.get<CommanderStatusAPIResponse[]>(
      `${this.backendDeviceStatusServiceURL}/connection?ids=${JSON.stringify(
        commandersId
      )}`
    );
    return response;
  };
}
